import React, { useState, useRef, useEffect } from 'react';
import {
    FormControlLabel, Checkbox, TextField, InputAdornment, Box, Dialog, DialogTitle, DialogContent, FormControl,
    RadioGroup, Radio, DialogActions, Avatar, Slide
} from "@mui/material";
import person1 from "../../../../Assets/img/person1.svg";
import { FaStar } from 'react-icons/fa';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import { MdOutlinePhoneIphone } from "react-icons/md";
import PublicIcon from '@mui/icons-material/Public';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { ReactComponent as WhatsappFilled } from '../../../../Assets/img/icons/whatsapp-filled.svg';
import { ReactComponent as VideoCallFilled } from '../../../../Assets/img/icons/video-call-figma.svg';
import { ReactComponent as PaymentFilled } from '../../../../Assets/img/icons/payment-icon-figma.svg';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import ForumIcon from '@mui/icons-material/Forum';
import { ReactComponent as GroupChatFilled } from '../../../../Assets/img/icons/group-chat-figma.svg';
import { ReactComponent as VideoTutorialFilled } from '../../../../Assets/img/icons/video-tutorial-figma.svg';
import { FaSearch } from "react-icons/fa";
import VerifiedIcon from '@mui/icons-material/Verified';
import { useQuantityContext } from '../../../QuantityContext';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import useApi from '../../../Utilities/useAPI';
import { Button, IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import BlockIcon from '@mui/icons-material/Block';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as FavouriteStar } from "../../../../Assets/img/icons/Favourites star icon.svg";
import { ReactComponent as NonVerifiedTickNew } from "../../../../Assets/img/icons/Non-verified-icon.svg";
import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';

const dummyGroupData = {
    name: "Example Group",
    description: "This is an example group description.",
    members: [
        { img: person1, name: "Jukkoe Sisao", role: "Developer", email: "sibyl_kozey@gmail.com", verified: true },
    ]
};

function UnVerifiedContacts() {
    const { isEnabledCCE, ContactView } = useQuantityContext();
    const navigate = useNavigate();
    // For demonstration, assuming we fetched group details from an API
    // In reality, you would fetch this from your backend
    const group = dummyGroupData; // Replace with actual data fetching logic
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredMembers, setFilteredMembers] = useState(group.members);
    const [showDetails, setShowDetails] = useState(isEnabledCCE);
    const [isListView, setIsListView] = useState(ContactView === "List View"); // State to toggle list view
    const [expandedItem, setExpandedItem] = useState(null); // State to track expanded item
    const [openOverflowIndex, setOpenOverflowIndex] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});  // Initialize with an empty object for item selection
    const [selectAll, setSelectAll] = useState(false);        // State for "Select All" checkbox
    const [groupMembers, setGroupMembers] = useState([]);
    const [deleteConfirm, setdeleteConfirm] = useState(false);
    const [muteContact, setMuteContact] = useState(false);
    const { callApiFunction } = useApi();
    // Handle "Select All" logic
    const [showOptionsBar, setShowOptionsBar] = useState(false)

    const cceFunctions = [
        { icon: VideoCallFilled, function: undefined },
        { icon: WhatsappFilled, function: undefined },
        { icon: ForumIcon, function: undefined },
        { icon: GroupChatFilled, function: undefined },
        { icon: AttachFileIcon, function: undefined },
        { icon: VideoTutorialFilled, function: undefined },
        { icon: VolumeUpRoundedIcon, function: undefined },
        { icon: EmailIcon, function: undefined },
    ];
    const handleSelectAllChange = () => {
        const newSelectedItems = {};
        filteredMembers.forEach((member) => {
            newSelectedItems[member.contact_ref_id] = !selectAll;  // Use contact_ref_id instead of email
        });
        setSelectedItems(newSelectedItems);
        setShowOptionsBar(!selectAll);
        setSelectAll(!selectAll);
    };

    // Handle individual item selection
    const handleItemSelection = (contact_ref_id) => {
        const newSelectedItems = { ...selectedItems, [contact_ref_id]: !selectedItems[contact_ref_id] };
        setSelectedItems(newSelectedItems);

        // Update Select All state if needed
        // const allSelected = filteredMembers.every((member) => newSelectedItems[member.contact_ref_id]);
        // setSelectAll(allSelected);
        const hasSelectedItems = Object.values(newSelectedItems).some(isSelected => isSelected);
        setShowOptionsBar(hasSelectedItems);
    };

    // console.log("Selected Items are", selectedItems);

    useEffect(() => {
        setShowDetails(isEnabledCCE);
    }, [isEnabledCCE]);

    useEffect(() => {
        setIsListView(ContactView === "List View");
    }, [ContactView]);

    useEffect(() => {
        setFilteredMembers(
            groupMembers.filter(member =>
                member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                member.role.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, groupMembers]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    function generateRandomDate() {
        const start = new Date(2020, 0, 1); // Start date (1st January 2020)
        const end = new Date(); // Current date
        const randomDate = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));

        // Format the date as 'Apr 21, 2024'
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return randomDate.toLocaleDateString('en-US', options);
    }

    const toggleOverflow = (index) => {
        setOpenOverflowIndex((prev) => {
            const newState = [...prev];
            newState[index] = !newState[index];
            return newState;
        });
    };

    const toggleExpand = (index) => {
        if (expandedItem === index) {
            setExpandedItem(null); // Collapse if already expanded
        } else {
            setExpandedItem(index); // Expand the clicked item
        }
    };

    useEffect(() => {
        // Fetch contacts from the API
        const fetchContacts = async () => {
            try {
                const response = await callApiFunction('ConnectedContacts');

                const data = response;

                if (data.statusCode === 200) {
                    const members = data.data.filter(member => !member.is_verified)  // Filter for favourite contacts
                        .map(member => {
                            const role = member.designation || member.field_of_study || member.title || '---';  // New role logic
                            const subTitle = member.profession_department || member.institute || member.nickname || '---';  // New subTitle logic

                            return {
                                img: member.profile_url,
                                contact_ref_id: member.contact_ref_id,
                                name: `${member.first_name} ${member.last_name}`,
                                role: role,  // Based on new logic
                                verified: member.is_verified ? true : false,
                                is_favourite: member.is_favourite ? true : false,  // Since we are filtering for favourites
                                subTitle: subTitle,  // Based on new logic
                                phone_no: member.phone_no?.replace(/[\s-]/g, ''),
                                email: member?.email,
                            };
                        });

                    setGroupMembers(members);
                    setFilteredMembers(members);
                }
            } catch (err) {
                console.log('An error occurred while sending the connection request:', err);
            }
        };

        fetchContacts();
    }, []);

    const handleDelete = async () => {
        const contact_ref_ids = Object.keys(selectedItems)
            .filter(id => selectedItems[id])
            .map(id => parseInt(id, 10)); // Ensure IDs are integers

        // Update selectedGroupMembers and filteredMembers by removing deleted contacts
        setGroupMembers((prevMembers) => {
            const updatedMembers = prevMembers.filter((member) => !contact_ref_ids.includes(member.contact_ref_id));
            return updatedMembers;
        });

        setFilteredMembers((prevMembers) => {
            const updatedMembers = prevMembers.filter((member) => !contact_ref_ids.includes(member.contact_ref_id));
            return updatedMembers;
        });

        // Optionally, clear the selected items if needed
        setSelectedItems((prevSelectedItems) => {
            const updatedSelectedItems = { ...prevSelectedItems };
            contact_ref_ids.forEach(id => {
                delete updatedSelectedItems[id];
            });
            return updatedSelectedItems;
        });

        setdeleteConfirm(false);
        // console.log("Selected Items will be")
        try {
            const response = await callApiFunction('deleteContacts', {
                contact_ref_ids: contact_ref_ids,
            });
            // console.log("Deleted Successfully", response);
        } catch (error) {
            console.log('Error uploading file:', error.message);
        }

    }

    const handleSaveMute = () => {
    }
    const selectedContacts = Object.keys(selectedItems).filter(key => selectedItems[key]);

    const toggleFavoriteStatus = async (contact_ref_id, currentStatus) => {
        try {
            // Update favorite status locally after the API call succeeds
            setGroupMembers((prevMembers) =>
                prevMembers.map((member) =>
                    member.contact_ref_id === contact_ref_id
                        ? { ...member, is_favourite: !member.is_favourite }
                        : member
                )
            );
            setFilteredMembers((prevMembers) =>
                prevMembers.map((member) =>
                    member.contact_ref_id === contact_ref_id
                        ? { ...member, is_favourite: !member.is_favourite }
                        : member
                )
            );
            const response = await callApiFunction('favouriteContact', {
                is_favourite: !currentStatus,
                contact_ref_id: contact_ref_id
            });
            // console.log("Favourite Card Updated", response.message);
        } catch (err) {
            console.log('Error updating favorite status:', err);
        }
    };

    const handleNavigate = (id) => {
        const encryptedId = CryptoJS.AES.encrypt(id.toString(), 'UserDetailsSecretKey').toString();
        // navigate(`/userDetailedInfo/${encodeURIComponent(encryptedId)}`)
        navigate(`/userDetailedInfo?encryptedId=${encodeURIComponent(encryptedId)}`);
    }

    return (
        <div className="outer-layer-of-contacts">
            <div className="outer-container">
                <div className="displayflex justify-content-between align-items-center">
                    <h6 className="fw-bold">All Contacts</h6>
                    <div className="flex-center">
                        {!isListView &&
                            <div className="">
                                <FormControlLabel
                                    className='customized_formControl'
                                    control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} />}
                                    label="Select All"
                                />
                            </div>}
                        <div style={{ marginRight: '10px' }}>
                            <TextField
                                placeholder="Search..."
                                variant="outlined"
                                size="small"
                                className="me-2"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <div className="icon">
                                                <FaSearch className="icon-color" />
                                            </div>
                                        </InputAdornment>
                                    ),
                                }}
                                style={{ width: '320px' }}
                            />
                        </div>
                    </div>
                </div>

                {!isListView ? (
                    <div className="avatars-container">
                        {filteredMembers.map((member, index) => (
                            <div key={index} className={`avatar-box-outer ${!showDetails ? 'compact' : ''}`}>
                                <div className={`avatar-box t ${!showDetails ? 'compact' : ''}`}>
                                    <div className="flex-center avatar-details-wrapper pointer" onClick={() => { handleNavigate(member.contact_ref_id) }}>

                                        {selectAll ? (
                                            <div className="dot_status_contacts">

                                                <Checkbox
                                                    checked={selectedItems[member.contact_ref_id] || false}
                                                    onClick={(e) => e.stopPropagation()} // Prevent click propagation
                                                    onChange={(e) => {
                                                        e.stopPropagation(); // Stop event from bubbling up
                                                        handleItemSelection(member.contact_ref_id);
                                                    }}
                                                    className="member-checkbox p-0"
                                                />


                                                {/* <Checkbox
                                                        checked={selectedItems[member.contact_ref_id] || false}  // Changed to contact_ref_id
                                                        onChange={() => handleItemSelection(member.contact_ref_id)}  // Changed to contact_ref_id
                                                        className="member-checkbox p-0"
                                                    /> */}
                                            </div>
                                        ) : (
                                            <div className="dot_status_contacts"
                                                style={{ backgroundColor: member.verified ? "#43A047" : "#EB4E3D" }}></div>
                                        )}

                                        <div className='star_fav_cards' onClick={(e) => {
                                            e.stopPropagation();
                                            toggleFavoriteStatus(member.contact_ref_id, member.is_favourite)
                                        }}>
                                            {member.is_favourite ? (
                                                <FaStar color={"#FCB809"} style={{ width: "20px", height: "20px" }} />
                                            ) : (
                                                <FavouriteStar />
                                            )}
                                        </div>
                                        <div className="avatar-details t">
                                            <div>
                                                <div className="avatar-image t">
                                                    {/* <img className='cover-image' src={member.img} alt={member.name} /> */}
                                                    <Avatar
                                                        className="w-100 h-100 cover-image" style={{ fontSize: "3rem" }}
                                                        alt={member.name}
                                                        src={member.img || undefined}
                                                    >{member.name.charAt(0).toUpperCase()}</Avatar>
                                                </div>
                                                <div className={`symbol_of_contacts ${!showDetails ? 'compact' : ''}`}>
                                                    {member.verified ?
                                                        <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                        <NonVerifiedTickNew />
                                                    }
                                                </div>
                                            </div>
                                            {/* {showDetails && <div className="vertical-line"></div>} */}
                                            <div className="member-info word-break">
                                                <Tooltip title={member.name} placement="bottom">
                                                    <div className="member-name">
                                                        {member.name.length > 10
                                                            ? `${member.name.slice(0, 10)}...`
                                                            : member.name}
                                                    </div>
                                                </Tooltip>
                                                <div className="member-role">{member.role}</div>
                                                {showDetails && <div className="member-email truncate">{member.subTitle}</div>}
                                            </div>
                                        </div>
                                    </div>

                                    {showDetails && (
                                        <>
                                            <div className="icons-container">
                                                <a href={`tel:${member?.phone_no}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                    <div className=""><MdOutlinePhoneIphone className="icon" /></div>
                                                </a>
                                                <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                    <div className=""><SmsIcon className="icon" /></div>
                                                </a>
                                                <a href={`mailto:${member?.email}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                    <div className=""><EmailIcon className="icon" /></div>
                                                </a>
                                                <a href={`https://wa.me/${member?.phone_no}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                    <div className=""><WhatsappFilled className="icon figma-icon" /></div>
                                                </a>
                                                <div className="icon-box"><MoreHorizIcon className="icon" onClick={() => toggleOverflow(index)} /></div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                {showDetails && openOverflowIndex[index] && (
                                    <>
                                        <div className="overflow-menu icons-container ms-2">
                                            <div className="icon-box"><AttachFileIcon className="icon" /></div>
                                            <div className="icon-box"><PublicIcon className="icon" /></div>
                                            <div className="icon-box"><VideoCallFilled className="icon figma-icon" /></div>
                                            <div className="icon-box"><VolumeUpRoundedIcon className="icon" /></div>
                                            <div className="icon-box"><PaymentFilled className="icon figma-icon" /></div>
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="list-container">
                        <ul className="members">
                            {/* Column headers */}
                            <div className="header-row">
                                <div className="header-column select-all me-3">
                                    <FormControlLabel
                                        className='customized_formControl ms-3'
                                        control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} className='ps-0' />}
                                        label="Select All"
                                    />
                                </div>
                                <div className="header-column name-email-details-column">
                                    Name and Email
                                </div>
                                <div className="header-column name-email-details-column">
                                    Details
                                </div>
                                <div className="header-column date">
                                    Date
                                </div>
                                <div className="header-column actions">
                                    Actions
                                </div>
                            </div>
                            {filteredMembers.map((member, index) => (
                                <div key={index} className={`list-item-container ${expandedItem === index ? 'expanded' : ''}`}>
                                    <li key={index} className={`list-item ${expandedItem === index ? 'expanded' : ''}`} onClick={() => { handleNavigate(member.contact_ref_id) }}>
                                        <div className='d-flex align-items-center header-column select-all ms-3' style={{ position: "relative" }}>
                                            <Checkbox onClick={(e) => e.stopPropagation()} // Prevent click propagation
                                                checked={selectedItems[member.contact_ref_id] || false}  // Changed to contact_ref_id
                                                onChange={() => handleItemSelection(member.contact_ref_id)}  // Changed to contact_ref_id
                                                className="member-checkbox p-0"
                                            />
                                            <div className="list-avatar" style={{ position: "absolute", right: "10%" }}>
                                                <div className='w-100 h-100' style={{ position: "relative" }}>
                                                    <Avatar style={{ fontSize: "2rem" }}
                                                        className="w-100 h-100 cover-image"
                                                        alt={member.name}
                                                        src={member.img || undefined}
                                                    >{member.name.charAt(0).toUpperCase()}</Avatar>

                                                    <div className={`symbol_of_contacts2_list`}>
                                                        {member.verified ?
                                                            <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                            <NonVerifiedTickNew />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="name-email-details header-column name-email-details-column">
                                            <span className="list-name">{member.name}</span>
                                            <span className="list-email">{member.subT}</span>
                                        </div>
                                        <span className="list-role header-column name-email-details-column">{member.role}</span>
                                        <span className="list-date header-column date">{generateRandomDate()}</span>
                                        <span onClick={(e) => { e.stopPropagation(); toggleFavoriteStatus(member.contact_ref_id, member.is_favourite); }} className="list-actions header-column actions align-items-center icon-20px">
                                            {member.is_favourite ? (
                                                <FaStar color={"#FCB809"} style={{ width: "20px", height: "20px" }} />
                                            ) : (
                                                <FavouriteStar />
                                            )}
                                            <MoreVertIcon className={`ms-2 ${expandedItem === index ? 'color-blue' : 'icon-color'}`} onClick={() => toggleExpand(index)} />
                                        </span>

                                        {expandedItem === index && (
                                            <div className="group-options-bar additional-info">
                                                <div className="group-option-box">
                                                    <EmailIcon className="pointer" />
                                                </div>
                                                <div className="group-option-box">
                                                    <VolumeUpRoundedIcon className="pointer" />
                                                </div>
                                                <div className="group-option-box">
                                                    <VideoTutorialFilled className="pointer figma-icon" />
                                                </div>
                                                <div className="group-option-box">
                                                    <AttachFileIcon className="pointer figma-icon" />
                                                </div>
                                                <div className="group-option-box">
                                                    <GroupChatFilled className="pointer figma-icon" />
                                                </div>
                                                <div className="group-option-box">
                                                    <ForumIcon className="pointer" />
                                                </div>
                                                <div className="group-option-box">
                                                    <WhatsappFilled className="pointer figma-icon" />
                                                </div>
                                                <div className="group-option-box">
                                                    <VideoCallFilled className="pointer figma-icon" />
                                                </div>
                                            </div>
                                        )}
                                    </li>
                                </div>
                            ))}
                        </ul>
                    </div>
                )}
                {/* <Slide direction="left" in={showOptionsBar} mountOnEnter unmountOnExit>
                    <div className={`group-options-bar ${showOptionsBar === true ? 'show-options' : ''}`} style={{ top: '80px', right: '0px' }}>
                        <div className="group-option-box">
                            <VideoCallFilled className="pointer figma-icon" />
                        </div>
                        <div className="group-option-box">
                            <WhatsappFilled className="pointer figma-icon" />
                        </div>
                        <div className="group-option-box">
                            <ForumIcon className="pointer" />
                        </div>
                        <div className="group-option-box">
                            <GroupChatFilled className="pointer figma-icon" />
                        </div>
                        <div className="group-option-box">
                            <AttachFileIcon className="pointer figma-icon" />
                        </div>
                        <div className="group-option-box">
                            <VideoTutorialFilled className="pointer figma-icon" />
                        </div>
                        <div className="group-option-box">
                            <VolumeUpRoundedIcon className="pointer" />
                        </div>
                        <div className="group-option-box">
                            <EmailIcon className="pointer" />
                        </div>
                    </div>
                </Slide> */}
            </div>

            {selectedContacts.length > 0 && (
                <div className={`action-bar ${Object.keys(selectedItems).length > 0 ? 'open' : ''}`}>
                    {cceFunctions.map((item, index) => {
                        const SvgIcon = item.icon; // Get the component reference
                        return (
                            <a href={item.href} target="_blank" rel="noreferrer" key={index}>
                                <IconButton className="white-icon-hover me-4" onClick={item.function} key={index}>
                                    <SvgIcon className='white-svg svg-icon-32px' />
                                </IconButton>
                            </a>
                        )
                    })}
                </div>
            )}
            {/* 
            <LayoutBox deleteConfirm={deleteConfirm} setdeleteConfirm={setdeleteConfirm} handleDeleteCard={handleDelete}
                muteContact={muteContact} setMuteContact={setMuteContact} handleSaveMute={handleSaveMute} /> */}
        </div>
    );
}

// const LayoutBox = ({ deleteConfirm, setdeleteConfirm, handleDeleteCard, muteContact, setMuteContact, handleSaveMute }) => {

//     const [selectedOption, setSelectedOption] = useState('');

//     const handleChange = (event) => {
//         setSelectedOption(event.target.value);
//     };

//     return (
//         <>
//             {deleteConfirm &&
//                 <div className="lightbox-overlay">
//                     <div className="lightbox-content p-4" style={{ minWidth: "40%" }}>
//                         <div className='d-flex align-items-center justify-content-between'>
//                             <h6 className='mb-0' style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>Delete the Card</h6>
//                             <IconButton onClick={() => setdeleteConfirm(false)}>
//                                 <CloseRoundedIcon />
//                             </IconButton>
//                         </div>

//                         <Typography variant="body2" className="text-muted">Are you sure you want to delete?</Typography>

//                         <div className='d-flex justify-content-end'>
//                             <Button onClick={() => setdeleteConfirm(false)} className="mx-2 mt-2">
//                                 CANCEL
//                             </Button>
//                             <Button onClick={handleDeleteCard} className="delete-button_configuration mt-2">
//                                 DELETE
//                             </Button>
//                         </div>

//                     </div>
//                 </div>
//             }

//             <Dialog open={muteContact} onClose={() => { setMuteContact(false) }} maxWidth="sm">
//                 <DialogTitle className='d-flex'>
//                     Mute the Contact
//                     <IconButton
//                         aria-label="close"
//                         onClick={() => { setMuteContact(false) }}
//                         sx={{
//                             position: 'absolute',
//                             right: 8,
//                             top: 10,
//                             color: (theme) => theme.palette.grey[500],
//                         }}
//                     >
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent>
//                     <FormControl component="fieldset">
//                         <RadioGroup value={selectedOption} onChange={handleChange}>
//                             <FormControlLabel value="1 hour" control={<Radio />} label="1 hour" />
//                             <FormControlLabel value="8 hours" control={<Radio />} label="8 hours" />
//                             <FormControlLabel value="7 days" control={<Radio />} label="7 days" />
//                             <FormControlLabel value="indefinite" control={<Radio />} label="Until I Turn It Back On" />
//                         </RadioGroup>
//                     </FormControl>
//                 </DialogContent>
//                 <DialogActions>
//                     <div className='d-flex justify-content-end'>
//                         <Button onClick={() => setMuteContact(false)} className="me-3" style={{ color: "#0044c6" }}>
//                             CANCEL
//                         </Button>
//                         <Button onClick={() => { handleSaveMute(selectedOption) }} variant="contained" className='color-blue' sx={{ backgroundColor: "#0044C6" }}
//                             style={{ marginBottom: "10px", marginRight: "10px" }}>
//                             Save
//                         </Button>
//                     </div>
//                 </DialogActions>
//             </Dialog>
//         </>
//     )
// }

export default UnVerifiedContacts;
